<template>
  <div class="collection" ref="publish">
    <MessageItem v-for="item of list" :key="item.id" v-bind="item"/>
    <van-loading class="loading" v-show="loading" size="24px">加载中...</van-loading>
  </div>
</template>
<script>
import MessageItem from './messageItem'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { isAndroid } from '../../../utils/utils'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('message')
export default {
  components: {
    MessageItem
  },
  data () {
    return {
      isAndroid: isAndroid(),
      list: [],
      page: 1,
      size: 10,
      count: 0,
      loading: true
    }
  },
  activated () {
    this.pageInit()
    this.getMessageList()
  },
  mounted () {
    this.getUserMessageList()
  },
  methods: {
    ...mapActions({
      updateCount: 'updateCount'
    }),
    pageInit () {
      this.loading = false
      this.page = 1
      this.size = 10
      this.count = 0
    },
    // 获取数据
    getMessageList () {
      const user = getUser('user')
      this.loading = true
      const promise = get({
        url: `/user/getMessage/${user.id}?page=${this.page}&size=${this.size}`
      })
      promise.then(res => {
        this.updateCount(0)
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.loading = false
          this.count = detail.total_count
          const list = detail.list.filter(item => {
            return (item.isUp || item.content) && (item.circle || item.tale || item.diss)
          })
          this.list.push(...list)
        }
      }).catch(() => {
      })
    },
    getUserMessageList () {
      const el = this.$refs.publish
      const offsetHeight = el.offsetHeight
      el.addEventListener('scroll', () => {
        if (this.loading) {
          return
        }
        const scrollHeight = el.scrollHeight
        const scrollTop = el.scrollTop
        if (offsetHeight + scrollTop >= scrollHeight) {
          const { count, list, page } = this
          if (count > list.length) {
            this.page = page + 1
            el.scrollTop = el.scrollTop - 60
            this.getMessageList(page, this.size)
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.collection {
  // position: absolute;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 3.47%;
  height: 100vh;
  padding-bottom: 20px;
  overflow-y: scroll;
  background: #fff;
  .loading {
    width: 100px;
    margin-left: 50%;
    left: -50px;
  }
}
</style>
